'use strict';

angular.module('atex.dam').controller('DamListContentViewController', ['$scope', '$state', '$stateParams',
function($scope, $state, $stateParams) {
  
  $scope.selected  = [];
  $scope.toggle='col-lg-7';

  $scope.entries = $stateParams.items; 
  
  if (!$scope.entries) {
    $state.go('list');
  }
  
  $scope.back = function() {
    $state.go('list');
  };
  
  $scope.clearSelection = function() {
    $scope.selected.length = 0;
  };
}]);

